module.exports = __webpack_public_path__ + "static/media/wire.4c3efd8c.svg";